export enum AdminProgramTableColumnDataIndex {
  Name = "name",
  Description = "description",
  DropOut = "dropOut",
  Status = "status",
  Link = "link",
  Options = "options",
}
